import { InjectionToken } from "@angular/core";

import type { IAuthContext } from "./i-auth-context";

/**
 * The resolved auth context for THIS host, computed once at bootstrap from
 * window.location by resolveAuthContext. Consumers (the AUTH_PROVIDER factory,
 * Auth0AuthService, the login screen) read it to pick the IdP / organization.
 */
export const AUTH_CONTEXT = new InjectionToken<IAuthContext>("AUTH_CONTEXT");
